function jsonObjectRearrange(jsonObject) {
    function getValueForLabel(label) {
        for (const step of Object.values(jsonObject)) {
            for (const item of step) {
                if (item.label === label) {
                    return item.value;
                }
            }
        }
        return null; // Label not found
    }

    function getLabelFormObject(label) {
        for (const step of Object.values(jsonObject)) {
            for (const item of step) {
                if (item.label === label) {
                    return item.labelTitle;
                }
            }
        }
        return null; // Label not found
    }

    function getFormattedDate(label) {
        const birthDate = getValueForLabel(label)
        const input_format = new Date(birthDate);
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return input_format.toLocaleDateString("mar-IN", options)
    }
    function convertTo12HourFormat(label) {
        const birthtime = getValueForLabel(label)
        var splitedTime = birthtime.split(':');
        var hours = parseInt(splitedTime[0]);
        var minutes = parseInt(splitedTime[1]);
    
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // Handle midnight (0 hours)
    
        return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ' ' + ampm;
    }

    return {
        step1: [
            {
                label: "name",
                labelTitle: getLabelFormObject("name"),
                value: getValueForLabel("name")
            },
            {
                label: "birthDate",
                labelTitle: getLabelFormObject("birthDate"),
                value: getFormattedDate("birthDate")
            },
            {
                label: "birthTime",
                labelTitle: getLabelFormObject("birthTime"),
                value: convertTo12HourFormat("birthTime")
            },
            {
                label: "birthPlace",
                labelTitle: getLabelFormObject("birthPlace"),
                value: getValueForLabel("birthPlace")
            },
            {
                label: "birthName",
                labelTitle: getLabelFormObject("birthName"),
                value: getValueForLabel("birthName")
            },
            {
                label: "castReligion",
                labelTitle: getLabelFormObject("castReligion"),
                value: getValueForLabel("castReligion")
            },
            {
                label: "familyGod",
                labelTitle: getLabelFormObject("familyGod"),
                value: getValueForLabel("familyGod")
            },
            {
                label: "gotr",
                labelTitle: getLabelFormObject("gotr"),
                value: getValueForLabel("gotr")
            },
            {
                label: "devak",
                labelTitle: getLabelFormObject("devak"),
                value: getValueForLabel("devak")
            },
            {
                label: "nakshytra",
                labelTitle: getLabelFormObject("nakshytra"),
                value: getValueForLabel("nakshytra")
            },
            {
                label: "rashi",
                labelTitle: getLabelFormObject("rashi"),
                value: getValueForLabel("rashi")
            },
            {
                label: "gan",
                labelTitle: getLabelFormObject("gan"),
                value: getValueForLabel("gan")
            },
            {
                label: "nadi",
                labelTitle: getLabelFormObject("nadi"),
                value: getValueForLabel("nadi")
            },
            {
                label: "height",
                labelTitle: getLabelFormObject("height"),
                value: getValueForLabel("height")
            },
            {
                label: "color",
                labelTitle: getLabelFormObject("color"),
                value: getValueForLabel("color")
            },
            {
                label: "bloodgroup",
                labelTitle: getLabelFormObject("bloodgroup"),
                value: getValueForLabel("bloodgroup")
            },
            {
                label: "job",
                labelTitle: getLabelFormObject("job"),
                value: getValueForLabel("job")
            },
            {
                label: "education",
                labelTitle: getLabelFormObject("education"),
                value: getValueForLabel("education")
            },
            {
                label: "income",
                labelTitle: getLabelFormObject("income"),
                value: getValueForLabel("income")
            },
            {
                label: "aboutme",
                labelTitle: getLabelFormObject("aboutme"),
                value: getValueForLabel("aboutme")
            }
        ],
        step2: [
            {
                label: "fatherName",
                labelTitle: getLabelFormObject("fatherName"),
                value: getValueForLabel("fatherName")
            },
            {
                label: "motherName",
                labelTitle: getLabelFormObject("motherName"),
                value: getValueForLabel("motherName")
            },
            {
                label: "brother1",
                labelTitle: getLabelFormObject("brother1"),
                value: getValueForLabel("brother1")
            },
            {
                label: "brother2",
                labelTitle: getLabelFormObject("brother2"),
                value: getValueForLabel("brother2")
            },
            {
                label: "brother3",
                labelTitle: getLabelFormObject("brother3"),
                value: getValueForLabel("brother3")
            },
            {
                label: "sister1",
                labelTitle: getLabelFormObject("sister1"),
                value: getValueForLabel("sister1")
            },
            {
                label: "sister2",
                labelTitle: getLabelFormObject("sister2"),
                value: getValueForLabel("sister2")
            },
            {
                label: "sister3",
                labelTitle: getLabelFormObject("sister3"),
                value: getValueForLabel("sister3")
            }
        ],
        step3: [
            {
                label: "paternalUncle1",
                labelTitle: getLabelFormObject("paternalUncle1"),
                value: getValueForLabel("paternalUncle1")
            },
            {
                label: "paternalUncle2",
                labelTitle: getLabelFormObject("paternalUncle2"),
                value: getValueForLabel("paternalUncle2")
            },
            {
                label: "maternalUncle1",
                labelTitle: getLabelFormObject("maternalUncle1"),
                value: getValueForLabel("maternalUncle1")
            },
            {
                label: "maternalUncle2",
                labelTitle: getLabelFormObject("maternalUncle2"),
                value: getValueForLabel("maternalUncle2")
            },
            {
                label: "grandfather1",
                labelTitle: getLabelFormObject("grandfather1"),
                value: getValueForLabel("grandfather1")
            },
            {
                label: "grandfather2",
                labelTitle: getLabelFormObject("grandfather2"),
                value: getValueForLabel("grandfather2")
            },
            {
                label: "relatives",
                labelTitle: getLabelFormObject("relatives"),
                value: getValueForLabel("relatives")
            }
        ],
        step4: [
            {
                label: "address",
                labelTitle: getLabelFormObject("address"),
                value: getValueForLabel("address")
            },
            {
                label: "mobileNumber",
                labelTitle: getLabelFormObject("mobileNumber"),
                value: getValueForLabel("mobileNumber")
            },
            {
                label: "expectations",
                labelTitle: getLabelFormObject("expectations"),
                value: getValueForLabel("expectations")
            }
        ],
        image: jsonObject.image
    };

}
module.exports = {
    jsonObjectRearrange
};